import { render } from "./Hijos.vue?vue&type=template&id=f0d084ce&scoped=true"
import script from "./Hijos.vue?vue&type=script&lang=js"
export * from "./Hijos.vue?vue&type=script&lang=js"

import "./Hijos.vue?vue&type=style&index=0&id=f0d084ce&scoped=true&lang=css"

import exportComponent from "/var/www/html/genesis-git/vue-genesis/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0d084ce"]])

export default __exports__